import { doc, getDoc } from 'firebase/firestore';
import { firestore } from 'services/firebase/client';
import type { SubscriptionHero } from 'utils/types/SubscriptionHero';

const COLLECTION = 'site_config';
const DOC_ID = 'subscription_hero';
const HOP_HEAD_DOC_ID = 'hop_head_subscription_hero';

/**
 * Busca a imagem fixa do hero da página de assinatura.
 * Usado na página de Assinatura (abaixo do texto "Só pedrada!").
 */
export async function getSubscriptionHero(): Promise<SubscriptionHero | null> {
  try {
    const ref = doc(firestore, COLLECTION, DOC_ID);
    const snapshot = await getDoc(ref);
    if (!snapshot.exists()) return null;
    const data = snapshot.data();
    if (!data?.image) return null;
    return {
      image: data.image,
      alt: data.alt ?? undefined,
      updatedAt: data.updatedAt,
    } as SubscriptionHero;
  } catch (error) {
    console.error('Erro ao buscar hero da assinatura:', error);
    return null;
  }
}

/**
 * Hero da página Série Hop Head (IPAs).
 * Documento opcional em site_config/hop_head_subscription_hero.
 */
export async function getHopHeadSubscriptionHero(): Promise<SubscriptionHero | null> {
  try {
    const ref = doc(firestore, COLLECTION, HOP_HEAD_DOC_ID);
    const snapshot = await getDoc(ref);
    if (!snapshot.exists()) return null;
    const data = snapshot.data();
    if (!data?.image) return null;
    return {
      image: data.image,
      alt: data.alt ?? undefined,
      updatedAt: data.updatedAt,
    } as SubscriptionHero;
  } catch (error) {
    console.error('Erro ao buscar hero Hop Head:', error);
    return null;
  }
}
